import { render } from "./unstyled-button.vue?vue&type=template&id=04df07fc&scoped=true"
import script from "./unstyled-button.vue?vue&type=script&lang=js"
export * from "./unstyled-button.vue?vue&type=script&lang=js"

import "./unstyled-button.vue?vue&type=style&index=0&id=04df07fc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04df07fc"]])

export default __exports__